import { objectEntries } from 'lib/object/objectUtils'
// eslint-disable-next-line no-restricted-imports
import { getContentColourUtilityClassName } from 'lib/theme/utilityClassNames'
import { css, ExecutionContext } from 'styled-components'

const contentColours: Record<App.Design.ContentColour, (props: ExecutionContext) => string> = {
  inherit: () => 'inherit',
  critical: props => props.theme.palette.messaging.critical.normalForeground,
  'critical-light': props => props.theme.palette.messaging.critical.lightForeground,
  favourite: props => props.theme.palette.messaging.favourite.normalForeground,
  exclusive: props => props.theme.palette.product.exclusive.foreground,
  'exclusive-contrast': props => props.theme.palette.product.exclusive.contrast,
  'highlight-primary': props => props.theme.palette.highlight.primary.normalForeground,
  'highlight-secondary': props => props.theme.palette.highlight.secondary.normalForeground,
  'highlight-tertiary': props => props.theme.palette.highlight.tertiary.normalForeground,
  'lux-plus': props => props.theme.palette.product.luxPlus.foreground,
  'neutral-eight': props => props.theme.palette.neutral.default.eight,
  'light-foreground-alt': props => props.theme.palette.neutral.surface.lightForegroundAlt,
  'neutral-five': props => props.theme.palette.neutral.default.five,
  'neutral-four': props => props.theme.palette.neutral.default.four,
  'neutral-one': props => props.theme.palette.neutral.default.one,
  'neutral-six': props => props.theme.palette.neutral.default.six,
  'neutral-three': props => props.theme.palette.neutral.default.three,
  'neutral-two': props => props.theme.palette.neutral.default.two,
  primary: props => props.theme.palette.brand.primary.normal,
  'primary-dark': props => props.theme.palette.brand.primary.dark,
  success: props => props.theme.palette.messaging.success.normalForeground,
  'success-dark': props => props.theme.palette.messaging.success.darkForeground,
  'tier-bronze': props => props.theme.palette.product.loyalty.bronze.normalForeground,
  'tier-bronze-dark': props => props.theme.palette.product.loyalty.bronze.darkForeground,
  'tier-bronze-light': props => props.theme.palette.product.loyalty.bronze.lightForeground,
  'tier-bronze-contrast': props => props.theme.palette.product.loyalty.bronze.normalContrast,
  'tier-bronze-dark-contrast': props => props.theme.palette.product.loyalty.bronze.darkContrast,
  'tier-bronze-light-contrast': props => props.theme.palette.product.loyalty.bronze.lightContrast,
  'tier-gold': props => props.theme.palette.product.loyalty.gold.normalForeground,
  'tier-gold-dark': props => props.theme.palette.product.loyalty.gold.darkForeground,
  'tier-gold-light': props => props.theme.palette.product.loyalty.gold.lightForeground,
  'tier-gold-contrast': props => props.theme.palette.product.loyalty.gold.normalContrast,
  'tier-gold-dark-contrast': props => props.theme.palette.product.loyalty.gold.darkContrast,
  'tier-gold-light-contrast': props => props.theme.palette.product.loyalty.gold.lightContrast,
  'tier-platinum': props => props.theme.palette.product.loyalty.platinum.normalForeground,
  'tier-platinum-dark': props => props.theme.palette.product.loyalty.platinum.darkForeground,
  'tier-platinum-light': props => props.theme.palette.product.loyalty.platinum.lightForeground,
  'tier-platinum-contrast': props => props.theme.palette.product.loyalty.platinum.normalContrast,
  'tier-platinum-dark-contrast': props => props.theme.palette.product.loyalty.platinum.darkContrast,
  'tier-platinum-light-contrast': props => props.theme.palette.product.loyalty.platinum.lightContrast,
  'tier-silver': props => props.theme.palette.product.loyalty.silver.normalForeground,
  'tier-silver-dark': props => props.theme.palette.product.loyalty.silver.darkForeground,
  'tier-silver-light': props => props.theme.palette.product.loyalty.silver.lightForeground,
  'tier-silver-contrast': props => props.theme.palette.product.loyalty.silver.normalContrast,
  'tier-silver-dark-contrast': props => props.theme.palette.product.loyalty.silver.darkContrast,
  'tier-silver-light-contrast': props => props.theme.palette.product.loyalty.silver.lightContrast,
  urgency: props => props.theme.palette.messaging.urgency.normalForeground,
  'urgency-dark': props => props.theme.palette.messaging.urgency.darkForeground,
  warning: props => props.theme.palette.messaging.warning.normalForeground,
}

const contentColoursStyle = objectEntries(contentColours).map(([colour, getter]) => css`.${getContentColourUtilityClassName(colour)} { color: ${getter}; }`)

export default contentColoursStyle
